<form [formGroup]="okrForm" (ngSubmit)="saveObjective(inProgress)">
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="ri-focus-3-line me-1 font-20 text-primary"></i> OKR for {{appraisal.label}}
    </h5>
    <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
      (click)="activeModal.close('Close')"></button>
  </div>
  <div class="modal-body rcx-table px-0 pb-0">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <ul class="nav nav-tabs pt-3 ps-3" role="tablist" formArrayName="quarters">
          <li class="nav-item" *ngFor="let okr of quarters.controls; let i=index;" [formGroupName]="i"
            (click)="currentTab=okr.value.quarterId" [class.active]="currentTab ===  okr.value.quarterId">
            <a class="nav-link " [class.active]="currentTab === okr.value.quarterId" [id]="i" data-bs-toggle="tab"
              href="#FIRST-QUATER" role="tab" [aria-controls]="i" aria-selected="true"><i
                class="bx bx-notepad align-middle pe-1"></i>{{okr.value.quarterName}}</a>
          </li>
        </ul>
        <ng-container formArrayName="quarters">
          <div *ngFor="let quarter of quarters.controls; let i=index;">
            <table class="table mt-1" id="table" [formGroupName]="i" *ngIf="currentTab ===  quarter.value.quarterId">
              <thead id="table-thead">
                <tr class="bg-light">
                  <th scope="col" width="300">Objective<b class="text-secondary">*</b></th>
                  <th scope="col" width="300">Key Result<b class="text-secondary">*</b></th>
                  <th scope="col" width="150">Self Rating</th>
                  <th scope="col" width="300">Comment</th>
                  <th scope="col" width="160" class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody formArrayName="objectives">
                <tr *ngFor="let objective of quarter.get('objectives').controls; let j=index" [formGroupName]="j">
                  <td class="col-lg-3 align-top">
                    <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                          class='bx bx-devices'></i></span>
                      <input type="text" class="form-control ps-1" id="objective" placeholder="Enter objective" [readonly]="appraisal?.active === false || okrStatus"
                        [ngClass]="{'is-invalid':objective.get('objective')?.touched && objective.get('objective')?.errors}"
                        formControlName="objective" ngbAutofocus autocomplete="off" />
                      <div class="invalid-feedback"
                        *ngIf="objective.get('objective')?.touched  && objective.get('objective')?.errors">
                        <span *ngIf="objective.get('objective')?.errors.required">Please provide a valid
                          Objective.</span>
                        <span *ngIf="objective.get('objective')?.errors.pattern">Only letters are allowed.</span>
                      </div>
                    </div>
                  </td>
                  <td class="col-lg-3 align-top">
                    <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                          class='bx bx-chart'></i></span>
                      <input type="text" class="form-control ps-1" id="keyResult" placeholder="Enter key result" [readonly]="appraisal?.active === false || okrStatus"
                        [ngClass]="{'is-invalid': objective.get('keyResult')?.touched  &&  objective.get('keyResult')?.errors}"
                        formControlName="keyResult" autocomplete="off" />
                      <div class="invalid-feedback" *ngIf="objective.get('keyResult')?.touched &&  objective.get('keyResult')?.errors">
                        <span *ngIf="objective.get('keyResult')?.errors.required">Please provide a valid Key Result.</span>
                        <span *ngIf="objective.get('keyResult')?.errors.pattern">Only letters are allowed.</span>
                      </div>
                    </div>
                  </td>
                  <td class="col-lg-3 align-top">
                    <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                          class='bx bx-star'></i></span>
                      <input type="number" class="form-control ps-1" id="selfRating" placeholder="Self Rating (0.1 to 1)"
                        [ngClass]="{'is-invalid': objective.get('selfRating')?.touched && submitted && selfRating.errors}" 
                        [readonly]="!isObjectiveEnabled || appraisal?.active === false || okrStatus" 
                        formControlName="selfRating" autocomplete="off"/>
                        <div class="invalid-feedback" *ngIf="submitted && objective.get('selfRating')?.touched && objective.get('selfRating')?.errors">
                          <span *ngIf="objective.get('selfRating')?.errors.required">Please provide a valid Key self Rating.</span>
                          <span *ngIf="objective.get('selfRating')?.errors.pattern">Only valid numbers (0.1 to 1) are allowed.</span>
                        </div>
                    </div>
                  </td>
                  <td class="col-lg-3 align-top">
                    <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                          class='bx bx-comment'></i></span>
                      <input type="text" class="form-control ps-1" id="comments" placeholder="Comments" 
                      [readonly]="!isObjectiveEnabled || appraisal?.active === false || okrStatus"
                        [ngClass]="{'is-invalid': objective.get('comments')?.touched && submitted && comments.errors}" 
                        formControlName="comments" autocomplete="off"  />
                      <div class="invalid-feedback" *ngIf="submitted && comments.errors">
                        <span *ngIf="objective.get('comments')?.errors.required">Please provide a valid comments.</span>                        
                          <span *ngIf="objective.get('comments')?.errors.pattern">Only letters are allowed.</span>
                        </div>
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center align-items-center"  *ngIf="appraisal?.active === true">
                      <button type="button" (click)="addObjective(i, objective)" class="btn btn-secondary btn-sm me-2"
                      *ngIf="j === (quarter.get('objectives')?.value?.length - 1)"  [disabled]="appraisal?.active === false || okrStatus">
                        <i class="bx bx-plus" title="Add objective"></i>
                      </button>
                      <button type="button" class="btn btn-danger btn-sm me-2" (click)="deleteObjective(i, j, objective)"
                      *ngIf="quarter.get('objectives')?.value?.length>1" [disabled]="appraisal?.active === false || okrStatus">
                        <i class="bx bx-trash" title="Delete objective"></i>
                      </button>
                    </div>
                  </td>                
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="activeModal.close('Close')"><i
        class="bx bx-x"></i>Close</button>
    <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}"
    [disabled]="appraisal?.active===false || okrStatus">
      <ng-container *ngIf="inProgress?.value=='true'">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{okrForm.value.id?'Updating...':'Saving...'}}
      </ng-container>
      <ng-container *ngIf="inProgress?.value!='true'">
        <i class="bx bx-save"></i>Save
      </ng-container>
    </button>
    <button *ngIf="isObjectiveEnabled" #submit type="button" class="btn btn-success" data-bs-dismiss="modal"
      (click)="submitObjective(submit,true)" [disabled]="appraisal?.active===false || okrStatus">
      <ng-container *ngIf="submit?.value=='true'"> 
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
         Submiting
      </ng-container>
      <ng-container *ngIf="submit?.value!='true'">
        <i class="bx bx-save"></i>Submit
      </ng-container>
    </button>
  </div>
</form>